'use strict';

/**
 * @author Maxim Seredkin
 * @param {StatusRestService} StatusRestService
 * @return {*}
 */
export default ['StatusRestService',
    function(StatusRestService) {
        return {
            getDisplayName: getDisplayName,
            api: StatusRestService,
        };

        /**
         * Получить имя для статуса
         * @param {string} status
         * @return {*}
         */
        function getDisplayName(status) {
            switch (status) {
                case 'ENABLED':
                    return 'Активен';
                    break;
                case 'DELETED':
                    return 'Удален';
                    break;
            }
        }
    }];
